import React from 'react';
import { View } from 'react-native';
import Text from '@/components/Typography/Text';
import { useLanding } from '@/components/Landing/LandingKit';
import { EditorialLink } from '@/components/Landing/LandingValueStory';
import { MODEL_TOTAL, PROVIDER_TOTAL } from '@/constants/aboutContent';
import { AboutBody, AboutSection, AboutSplit, AboutTitle } from './AboutKit';

const WORK_OUTPUTS = [
  { title: 'Super Intelligence films & video', detail: 'Footage, music, voiceover, and a finished film.' },
  { title: 'Research & real files', detail: 'Sourced briefs, slide decks, documents, and spreadsheets.' },
  { title: 'Code & playable games', detail: 'Websites, applications, and games you can run.' },
];

function ProductRow({ title, children, first = false }) {
  const { c, isCompact } = useLanding();
  return (
    <AboutSplit style={{ paddingTop: first ? 0 : 32, paddingBottom: 32, borderBottomWidth: 1, borderBottomColor: c.rule }}>
      <View style={{ flex: isCompact ? undefined : 0.8, minWidth: 0 }}>
        <Text tag="h3" weight="semibold" style={{ color: c.ink, fontSize: 23, lineHeight: 30, letterSpacing: -0.55 }}>{title}</Text>
      </View>
      <View style={{ flex: isCompact ? undefined : 1.6, minWidth: 0 }}>{children}</View>
    </AboutSplit>
  );
}

function AboutWorkspace() {
  const { c, band, isXS } = useLanding();
  return (
    <AboutSection label="What we’re building" background={band.bg}>
      <AboutTitle style={{ marginBottom: 38 }}>What we’re building.</AboutTitle>
      <ProductRow title="Gab AI Work" first>
        <AboutBody>
          A Super Intelligence agent with its own computer, browser, and access to {MODEL_TOTAL} models. Give it a project and it can research, write, design, code, and create the files. Follow its progress, review the results, and ask for changes.
        </AboutBody>
        <View style={{ gap: 16, marginTop: 24, marginBottom: 12 }}>
          {WORK_OUTPUTS.map(output => (
            <View key={output.title} style={{ flexDirection: isXS ? 'column' : 'row', gap: isXS ? 4 : 22 }}>
              <Text weight="medium" style={{ color: c.ink, fontSize: 14, lineHeight: 22, width: isXS ? undefined : 158 }}>{output.title}</Text>
              <Text style={{ flex: isXS ? undefined : 1, color: c.inkSoft, fontSize: 14, lineHeight: 22 }}>{output.detail}</Text>
            </View>
          ))}
        </View>
        <EditorialLink href="/pricing">Get Work with Plus</EditorialLink>
      </ProductRow>
      <ProductRow title="Chat & creative tools">
        <AboutBody>
          {MODEL_TOTAL} models from {PROVIDER_TOTAL} providers in one account. Write, reason, search the web, and create images, video, music, voice, and 3D. Choose a model yourself or let Auto choose one for the request.
        </AboutBody>
        <AboutBody style={{ marginTop: 14 }}>
          Keep your conversations and files together. Talk by voice, schedule recurring tasks, and choose what your Super Intelligence remembers between conversations.
        </AboutBody>
        <View style={{ flexDirection: 'row', flexWrap: 'wrap', columnGap: 28, marginTop: 12 }}>
          <EditorialLink href="/models">Explore the models</EditorialLink>
          <EditorialLink href="/tools">Browse the tools</EditorialLink>
        </View>
      </ProductRow>
      <ProductRow title="For developers">
        <AboutBody>
          Bring Gab AI into your own software with one API for text, image, video, and audio. Use our Python and Node.js SDKs, automatic model routing, and OpenAI-compatible endpoints.
        </AboutBody>
        <View style={{ flexDirection: 'row', flexWrap: 'wrap', columnGap: 28, marginTop: 12 }}>
          <EditorialLink href="/api">Explore the API</EditorialLink>
          <EditorialLink href="/docs">Read the documentation</EditorialLink>
        </View>
      </ProductRow>
    </AboutSection>
  );
}

export default React.memo(AboutWorkspace);
